import { inject, Injectable, OnDestroy } from '@angular/core';
import { FaviconService } from './favicon.service';
import { SoundService } from './sound.service';
import { DealHandler } from '../trade/realtime/deal.handler';
import { filter, fromEvent, Subscription } from 'rxjs';
import { WebsocketClientWrapper } from '../market/websocket-client-factory';
import { DealSoundService } from './deal-sound.service';

@Injectable({
  providedIn: 'root'
})
export class DealNotifyService implements OnDestroy {

  private dealHandler = inject(DealHandler)
  private dealSoundService = inject(DealSoundService)
  private faviconService = inject(FaviconService)
  private soundService = inject(SoundService)

  private documentVisibled = true
  private wsSubscriptions = new Map<WebsocketClientWrapper, Subscription>()

  private sb = fromEvent(document, 'visibilitychange').pipe(
    filter(() => this.documentVisibled = !document.hidden && document.visibilityState === 'visible')
  ).subscribe(() => this.faviconService.hideBadge())

  ngOnDestroy() {
    this.sb.unsubscribe()
    this.wsSubscriptions.forEach(sb => sb.unsubscribe())
  }

  addWs(ws: WebsocketClientWrapper) {
    const sb = this.dealHandler.listen(ws).subscribe(() => {
      if (!this.documentVisibled) {
        this.faviconService.showBadge()
      }
      if (this.dealSoundService.flag) {
        this.soundService.play('sound/doorbell.mp3')
      }
    })
    this.wsSubscriptions.set(ws, sb)
  }

  removeWs(ws: WebsocketClientWrapper) {
    const sb = this.wsSubscriptions.get(ws)
    if (sb) {
      sb.unsubscribe()
      this.wsSubscriptions.delete(ws)
    }
  }

}
